import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../features/auth/Login";
import { PrivateRoute } from "./PrivateRoute";
import { RoleBasedRoute } from "./RoleBasedRoute";
import PackageDetail from "../features/packages/PackageDetail";
import { ResellersList } from "../features/resellers/ResellerList";
import { PackagesList } from "../features/packages/PackageList";
import PosPackages from "../features/packages/PosPackages";
import PosPackageDetail from "../features/packages/PosPackageDetail";
import PosSaleQrScreen from "../features/packages/PosSaleQrScreen";
import AssignSimPackages from "../features/packages/AssignSimPackages";
import TopupEsimOnly from "../features/packages/TopupEsimOnly";
import ResellerBalance from "../features/resellers/ResellerBalance";
import { PublicRoute } from "./PublicRoute";

export function AppRoutes() {
    const token = localStorage.getItem('token');
    const isAuthenticated = !!token;
    
    
    return (
      <Routes>
       <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        
        <Route path="/" element={<RoleBasedRoute><PosPackages /></RoleBasedRoute>} />
        <Route path="/package/:id" element={<RoleBasedRoute><PosPackageDetail /></RoleBasedRoute>} />
        <Route path="/sale/qr" element={<RoleBasedRoute><PosSaleQrScreen /></RoleBasedRoute>} />
        <Route path="/assign-sim-package" element={<RoleBasedRoute><AssignSimPackages /></RoleBasedRoute>} />
        <Route path="/topUpEsim" element={<RoleBasedRoute><TopupEsimOnly /></RoleBasedRoute>} />
        <Route path="/balance" element={<RoleBasedRoute><ResellerBalance/></RoleBasedRoute>}/>
        
        <Route
          path="/resellers"
          element={
            <RoleBasedRoute>
              <ResellersList />
            </RoleBasedRoute>
          }
        />
        <Route
            path="/packages"
            element={
                <RoleBasedRoute>
                  <PackagesList />
                </RoleBasedRoute>
              }
        />
        {/* <Route
          path="packages"
          element={
            <RoleBasedRoute roles={['admin']}>
              <PackagesList />
            </RoleBasedRoute>
          }
        /> */}
  
        <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
      </Routes>
    );
  }
  